import { Modal } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import ButtonLoader from "../../../../../../UI/Loaders/Loaders";
import { useDispatch, useSelector } from "react-redux";
import { clearDocumentViewModalRecord } from "../../../../../../redux/actions/documenViewer";
import { MixPanel } from "../../../../../../shared/MixPanel/MixPanel";
import { Document, Page } from "react-pdf";

type CustomerPaperMandateProps = {
    showCustomerMandateModal: boolean;
    setShowCustomerMandateModal: Dispatch<SetStateAction<boolean>>;
    isFetchingDocument: boolean;
    setCustomerMandateUrl: Dispatch<SetStateAction<string>>
    handleDownload: (isTemplate: boolean) => void;
    isDownloading: boolean
}

const CustomerPaperMandate = (
    {
        showCustomerMandateModal,
        setShowCustomerMandateModal,
        isFetchingDocument,
        setCustomerMandateUrl,
        handleDownload,
        isDownloading
    }: CustomerPaperMandateProps) => {
    const [documentData, setDocumentData] = useState({
        documentUrl: "",
        type: "",
        isLoading: true,
    });

    const [numPages, setNumPages] = useState<number | null>(null);
    const dispatch = useDispatch();

    useEffect(() => {
        MixPanel.track(`Page View: CustomerMandateViewer.tsx`, {
            page: "CustomerMandateViewer.tsx",
        });
    }, []);

    const updatedDocumentData = useSelector(
        (state: any) => state?.documentViewerReducer,
    );

    useEffect(() => {
        if (updatedDocumentData?.documentUrl) {
            setDocumentData({
                documentUrl: updatedDocumentData?.documentUrl,
                type: updatedDocumentData?.type,
                isLoading: updatedDocumentData?.isLoading,
            });
        }
    }, [updatedDocumentData]);

    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
    };

    return (
        <Modal
            title=""
            width={950}
            open={showCustomerMandateModal}
            zIndex={9990}
            onCancel={() => setShowCustomerMandateModal(false)}
            footer={
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%"
                }}>
                    <button
                        key="cancel"
                        className="btn btn-secondary"
                        onClick={() => {
                            setShowCustomerMandateModal(false)
                            setCustomerMandateUrl("")
                            dispatch(clearDocumentViewModalRecord());
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        key="cancel"
                        className="btn advancly-btn"
                        onClick={() => handleDownload(false)}
                    >
                        {isDownloading ? "Downloading..." : "Download"}
                    </button>
                </div>
            }
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                {isFetchingDocument || documentData?.isLoading ? (
                    <ButtonLoader />
                ) :
                    <>
                        {/* Image preview */}
                        {documentData?.type?.startsWith("image/") && (
                            <img
                                src={documentData?.documentUrl}
                                alt="Preview"
                                style={{
                                    maxWidth: "1000px",
                                    maxHeight: "800px",
                                    objectFit: "contain",
                                }}
                            />
                        )}

                        {/* PDF preview (react-pdf) */}
                        {documentData?.type === "application/pdf" && (
                            <div
                                style={{
                                    width: "1000px",
                                    height: "800px",
                                    overflow: "auto",
                                }}
                            >
                                <Document
                                    file={documentData?.documentUrl}
                                    onLoadSuccess={onDocumentLoadSuccess}
                                    loading={<ButtonLoader />}
                                >
                                    {Array.from(new Array(numPages), (el, index) => (
                                        <Page
                                            key={`page_${index + 1}`}
                                            pageNumber={index + 1}
                                            width={900}
                                        />
                                    ))}
                                </Document>
                            </div>
                        )}

                        {/* Word/Excel/PowerPoint */}
                        {(documentData?.type?.includes("word") ||
                            documentData?.type?.includes("excel") ||
                            documentData?.type?.includes("presentation")) && (
                                <iframe
                                    src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                                        documentData?.documentUrl,
                                    )}`}
                                    width="1000"
                                    height="800"
                                    style={{ border: "none" }}
                                    title="Office Document Viewer"
                                />
                            )}

                        {/* Fallback for unknown types */}
                        {!documentData?.type?.startsWith("image/") &&
                            documentData?.type !== "application/pdf" &&
                            !(
                                documentData?.type?.includes("word") ||
                                documentData?.type?.includes("excel") ||
                                documentData?.type?.includes("presentation")
                            ) && (
                                <object
                                    type={documentData?.type}
                                    data={documentData?.documentUrl}
                                    width="1000"
                                    height="800"
                                    style={{ objectFit: "contain" }}
                                >
                                    <p>
                                        Cannot preview this file.{" "}
                                        <a
                                            href={documentData?.documentUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Download instead
                                        </a>
                                    </p>
                                </object>
                            )}
                    </>
                }
            </div>
        </Modal>
    )
}

export default CustomerPaperMandate